(() => {
  const link = document.querySelector('.ab-back-link');
  if (!link) return;
  try { sessionStorage.setItem('ab-auctions-source', location.pathname); } catch (_) {}
  const info = link.closest('.product__info');
  if (info) {
    const enhance = () => {
      const panel = info.querySelector('.tpa-product-widget');
      if (!panel) return;
      const status = panel.querySelector('.tpa-product-widget__status');
      const statusMessage = panel.querySelector('.tpa-heading-messenger');
      if (status) status.hidden = !statusMessage?.textContent.trim();
      const endLabel = panel.querySelector('.tpa-other-info__end_time .tpa-row__label');
      if (endLabel && endLabel.textContent !== 'Closes (Dubai time)') endLabel.textContent = 'Closes (Dubai time)';
      const endValue = panel.querySelector('.tpa-other-info__end_time .tpa-row__value');
      if (endValue && /^\s*\d{4}-\d{2}-\d{2} /.test(endValue.textContent)) {
        const date = new Date(endValue.textContent.trim().replace(' ', 'T') + '+04:00');
        if (!Number.isNaN(date.getTime())) endValue.textContent = new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'short',year:'numeric',hour:'numeric',minute:'2-digit',hour12:true,timeZone:'Asia/Dubai'}).format(date);
      }
      const label = panel.querySelector('.tpa-live_bid_label');
      if (label && label.textContent !== 'Your bid') label.textContent = 'Your bid';
      panel.querySelectorAll('button').forEach(button => {if(button.textContent.trim() === 'PLACE BID') button.textContent = 'Place bid';});
      if (!panel.querySelector('.ab-bid-help')) {
        const note = document.createElement('p');
        note.className = 'ab-bid-help';
        note.textContent = 'Sign in to place a bid.';
        panel.append(note);
      }
    };
    const normalize = node => {
      if (node.nodeType === Node.TEXT_NODE) {
        if (!node.parentElement?.closest('script,style,input,textarea') && /\bDhs\./.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/\bDhs\./g, 'AED');
        return;
      }
      for (const child of node.childNodes) normalize(child);
    };
    normalize(info);
    enhance();
    new MutationObserver(records => {records.forEach(record => {
      if (record.type === 'characterData') normalize(record.target);
      else record.addedNodes.forEach(normalize);
    });enhance();}).observe(info, {subtree:true, childList:true, characterData:true});
  }
  try {
    const value = new URLSearchParams(location.search).get('ab_return') || sessionStorage.getItem('ab-auctions-return');
    if (!value) return;
    const url = new URL(value, location.origin);
    if (url.origin !== location.origin || !/^\/collections\/auction\/?$/.test(url.pathname)) return;
    for (const key of [...url.searchParams.keys()]) if (!['category', 'sale', 'sort', 'available'].includes(key)) url.searchParams.delete(key);
    link.href = url.pathname + url.search;
  } catch (_) {}
})();
